import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpService} from '../service/http.service';
import {GlobalConfig} from '../../global';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-guide-item',
  templateUrl: './guide-item.component.html',
  styleUrls: ['./guide-item.component.css']
})
export class GuideItemComponent implements OnInit {
  leadershipItem: any;

  constructor(private http: HttpService,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.paramMap.get('id');

    this.getLeadershipByCity(id);
    // } else if (sessionStorage.countryObj) {
    // 	this.getLeadershipByCountry(leadershipId)
    // }
  }

  getLeadershipByCity(id) {
    this.http.getLeadershipByCityService(id).subscribe((data: any) => {
      console.log(data);
      this.leadershipItem = [];
      this.leadershipItem.push(data);
    });
  }

  getLeadershipByCountry(id) {
    let countryObj = JSON.parse(sessionStorage.countryObj);
    let countryId = countryObj.id;
    if (countryId) {
      this.http.getLeadershipByIdCountryService(id).subscribe((data: any) => {
        console.log(data);
        this.leadershipItem = [];
        this.leadershipItem.push(data);
      });
    }
  }

}
